/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useState } from 'react';
import { AppContext } from '../Index';

const Index = () => {
	const appStoreData = useContext(AppContext);
	const { menuData, selectedFamilyGroup, setSelectedFamilyGroup } = appStoreData;
	const [isCategoryVisisble, setIsCategoryVisisble] = useState(0);
	return (
		<div className="col-lg-3 p-0">

			<span className="category-item-btn" onClick={() => setIsCategoryVisisble(!isCategoryVisisble)}>
				Categories Menu
			</span>

			<div className={`${isCategoryVisisble ? "" : "items-hide"} items mt-3`}>
				<h4>Categories</h4>
				<ul>
					{
						menuData.map(item => {
							return (
								<li
									// className={`pointer ${selectedFamilyGroup === item.itemCode ? "selected" : ""}`}
									className={`pointer`}
									key={item.itemCode}
									onClick={() => {
										setSelectedFamilyGroup((selectedFamilyGroup === item.itemCode) ? null : item.itemCode);
										setIsCategoryVisisble(false)
									}}>
									<a
										href=""
										className={` ${selectedFamilyGroup === item.itemCode ? "selected" : ""}`}
										data-bs-toggle="collapse"
										data-bs-target={`#${item.itemCode}`}
										aria-expanded="true"
										aria-controls="collapseOne"
									>
										{item.name}
									</a>
								</li>
							)
						})
					}
				</ul>
			</div>
		</div>
	)
};

export default Index;
